import { useEffect } from 'react'
import { useUser } from 'utilities/hooks/useUser'

import StrategiesLayout from '../layout/strategies-layout'
import { actions as rawActions } from '../state/edit-strategy-slice'
import { useAppSelector } from '../store/hooks'
import { useActions } from '../store/use-actions'

export const StrategyAdminWithState = () => {
  const { data: user } = useUser()
  const state = useAppSelector(state => state.editStrategies)
  const actions = useActions(rawActions)
  useEffect(() => {
    actions.init()
  }, [actions])
  const canUserSave =
    user.organisation.organisationType === 'Administrator' ||
    user.roles.includes('Administrator') ||
    user.roles.includes('BankAdmin')

  return (
    <StrategiesLayout
      actions={actions}
      canProceed={state.canProceed && canUserSave}
      errors={state.errors}
      saveSuccess={state.saveSuccess}
      selectedStrategy={state.selectedStrategy}
      strategies={state.availableStrategies}
    />
  )
}
